import { render, staticRenderFns } from "./PtCompliance.vue?vue&type=template&id=70038c0a&scoped=true&"
import script from "./PtCompliance.vue?vue&type=script&lang=js&"
export * from "./PtCompliance.vue?vue&type=script&lang=js&"
import style0 from "./PtCompliance.vue?vue&type=style&index=0&id=70038c0a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70038c0a",
  null
  
)

export default component.exports